import { Asterisk } from "lucide-react";
import Reveal from "@/components/Reveal";

const FOOD_IMG =
  "https://images.pexels.com/photos/20593400/pexels-photo-20593400.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export function Marquee() {
  const items = [
    "Sustainable nutrition",
    "Weight & energy",
    "Stress & sleep",
    "1-on-1 coaching",
    "Dubai · online worldwide",
  ];
  const Row = ({ hidden }) => (
    <div className="flex items-center flex-none" aria-hidden={hidden || undefined}>
      {items.map((t) => (
        <span key={t} className="inline-flex items-center gap-10 pr-10 whitespace-nowrap">
          <span className="font-displaya font-semibold uppercase tracking-wide text-xl">{t}</span>
          <Asterisk className="w-6 h-6 text-royal" />
        </span>
      ))}
    </div>
  );
  return (
    <div className="bg-butter text-navy py-5 overflow-hidden" data-testid="marquee-band-a">
      <div className="flex w-max animate-marquee">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}

const SPECIALTIES = [
  {
    n: "01",
    t: "Nutrition & Sustainable Eating",
    d: "No extreme diets or rigid rules. We build an eating pattern that fits your real life — simple enough to follow, flexible enough to last.",
    img: FOOD_IMG,
    alt: "Fresh, colourful nourish bowl",
    bg: "bg-[#F4F8CD]",
  },
  {
    n: "02",
    t: "Weight & Energy, No Guesswork",
    d: "Steady progress beats quick fixes that don't stay. A clear, step-by-step plan, so you always know what to do next — and why it's working.",
    img: "/images/ak_w1.jpg",
    alt: "Akanksha practising yoga at home",
    bg: "bg-[#E3EDFB]",
  },
  {
    n: "03",
    t: "Stress, Sleep & Mindset",
    d: "Stress and self-doubt derail progress as much as any diet. Together we manage both, so consistency feels possible — not exhausting.",
    img: "/images/ak_w3.jpg",
    alt: "Akanksha meditating outdoors",
    bg: "bg-[#ECEEF2]",
  },
];

export function Specialties() {
  return (
    <section id="specialties" className="bg-[#F7F9FC] text-navy py-24" data-testid="specialties-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
          <Reveal>
            <h2 className="font-displaya font-extrabold uppercase text-[clamp(2.6rem,5vw,4.5rem)] leading-[0.95] text-royal">
              What I help with
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-xs text-navy/60">Three focus areas, one goal — habits that hold up in real life.</p>
          </Reveal>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {SPECIALTIES.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.12} className={`${s.bg} rounded-[2rem] p-4 pb-8 transition-transform duration-300 hover:-translate-y-1.5`}>
              <div data-testid={`specialty-card-${s.n}`} className="rounded-3xl overflow-hidden h-56">
                <img src={s.img} alt={s.alt} className="w-full h-full object-cover" loading="lazy" />
              </div>
              <div className="flex items-start justify-between gap-4 px-3 mt-6">
                <h3 className="text-2xl font-semibold leading-snug max-w-[230px]">{s.t}</h3>
                <span className="font-displaya font-bold text-5xl text-royal/20 leading-none">{s.n}</span>
              </div>
              <p className="px-3 mt-3 text-navy/70 leading-relaxed">{s.d}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}

const STEPS = [
  {
    n: "01",
    t: "Discover",
    d: "A proper conversation — your history, your routine, your life as it actually is. No forms for the sake of forms.",
  },
  {
    n: "02",
    t: "Design",
    d: "A personal protocol: nutrition, movement, sleep and stress — built around your days, your culture, your kitchen.",
  },
  {
    n: "03",
    t: "Sustain",
    d: "Regular check-ins and honest accountability, until the plan stops being a plan and becomes your normal.",
  },
];

export function Method() {
  return (
    <section className="bg-[linear-gradient(140deg,#3E6FBE_0%,#6E9BE0_100%)] text-cream py-24" data-testid="method-section">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <Reveal>
            <h2 className="font-displaya font-extrabold uppercase text-[clamp(2.6rem,5vw,4.5rem)] leading-[0.95]">
              The Well&Truly <span className="text-butter">way</span>
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-sm text-white/75">A three-step framework that turns good intentions into habits that hold.</p>
          </Reveal>
        </div>
        <div className="mt-14 grid md:grid-cols-3 gap-8">
          {STEPS.map((s, i) => (
            <Reveal key={s.n} delay={i * 0.12} className="border-t-2 border-white/25 pt-8">
              <span className="font-displaya font-bold text-7xl text-butter leading-none">{s.n}</span>
              <h3 className="mt-4 text-2xl font-semibold">{s.t}</h3>
              <p className="mt-3 text-white/75 leading-relaxed">{s.d}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
